import React from 'react';

export default function FollowIcon({ active = false, size = 22, ...props }) {
  const stroke = active ? 'rgba(255,215,0,0.9)' : 'rgba(255,215,0,0.6)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Person head */}
      <circle cx="9" cy="7" r="3.5" stroke={stroke} strokeWidth="1.6" />
      {/* Person body arc */}
      <path d="M2 21C2 17 5 14 9 14c2 0 3.8.8 5 2" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      {/* Plus sign */}
      <line x1="19" y1="13" x2="19" y2="21" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
      <line x1="15" y1="17" x2="23" y2="17" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
